import React from 'react';
import PropTypes from 'prop-types';
import { AppLink, AppTypography } from '@easyllama/ui-components';
import { closeOnPlainClick } from '../helpers';

function GroupHeading({ icon, label, count, seeAllUrl, onNavigate }) {
  return (
    <div className="flex items-center justify-between px-2 py-1.5">
      <div className="flex items-center gap-2">
        {icon}
        <AppTypography as="p" variant="body-14" className="!text-[length:var(--gs-label-font)] !font-bold uppercase tracking-(--gs-label-tracking) text-llama-grey-10">
          {count == null ? label : `${label} · ${count}`}
        </AppTypography>
      </div>
      {seeAllUrl && (
        <AppLink
          text="See all"
          href={seeAllUrl}
          size="small"
          className="!font-semibold !no-underline"
          onClick={(event) => closeOnPlainClick(event, onNavigate)}
        />
      )}
    </div>
  );
}

GroupHeading.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  seeAllUrl: PropTypes.string,
  onNavigate: PropTypes.func,
};

export default GroupHeading;
